import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SortOrder } from '../models';

@Component({
    selector: 'lib-sort',
    templateUrl: './sort.component.html',
    styleUrls: ['./sort.component.scss'],
    standalone: false
})
export class SortComponent {

  @Input() sortOrder: SortOrder | null = null;
  @Output() sortUpdated: EventEmitter<SortOrder | null> = new EventEmitter<SortOrder | null>();

  updateSort() {
    if (this.sortOrder === null) {
      this.sortUpdated.emit(SortOrder.Ascending);
    } else if (this.sortOrder === SortOrder.Ascending) {
      this.sortUpdated.emit(SortOrder.Descending);
    } else if (this.sortOrder === SortOrder.Descending) {
      this.sortUpdated.emit(this.sortOrder = null);
    }
  }
}
